import { render, staticRenderFns } from "./device_warn_history.vue?vue&type=template&id=235248f9&scoped=true"
import script from "./device_warn_history.vue?vue&type=script&lang=js"
export * from "./device_warn_history.vue?vue&type=script&lang=js"
import style0 from "./device_warn_history.vue?vue&type=style&index=0&id=235248f9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235248f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235248f9')) {
      api.createRecord('235248f9', component.options)
    } else {
      api.reload('235248f9', component.options)
    }
    module.hot.accept("./device_warn_history.vue?vue&type=template&id=235248f9&scoped=true", function () {
      api.rerender('235248f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_warn_history.vue"
export default component.exports